export default function HowWeHelpSection() {
  const process = [
    {
      num: "01",
      icon: "ri-search-eye-line",
      title: "Free Roof Inspection",
      desc: "We conduct a thorough inspection with photo documentation of every detail — damage, decking condition, flashing, ventilation, and more.",
      time: "Day 1",
    },
    {
      num: "02",
      icon: "ri-file-list-3-line",
      title: "Estimate Translation",
      desc: "We sit down with you and decode your insurance estimate line by line — in plain English. You&apos;ll know exactly what you&apos;re entitled to.",
      time: "Day 2–3",
    },
    {
      num: "03",
      icon: "ri-money-dollar-circle-line",
      title: "Depreciation Identification",
      desc: "We calculate your full recoverable depreciation holdback and identify any missing scope items that can be supplemented.",
      time: "Day 3",
    },
    {
      num: "04",
      icon: "ri-tools-line",
      title: "Certified Installation",
      desc: "We install your roof using manufacturer-certified materials and methods, documenting every step for warranty compliance and supplement filing.",
      time: "Week 2",
    },
    {
      num: "05",
      icon: "ri-file-add-line",
      title: "Supplement Filing",
      desc: "We document all additional items discovered during installation and file supplements with your carrier — at no extra cost to you.",
      time: "Week 2–3",
    },
    {
      num: "06",
      icon: "ri-bank-card-line",
      title: "Depreciation Recovery",
      desc: "We submit your completion documentation and help you recover your full holdback. Most homeowners receive a check they never expected.",
      time: "Week 4",
    },
  ];

  const comparisons = [
    { label: "Explains depreciation holdback", typical: false, ridgecap: true },
    { label: "Recovers 100% of your depreciation", typical: false, ridgecap: true },
    { label: "Files supplements for missed items", typical: false, ridgecap: true },
    { label: "Manufacturer-certified installation", typical: false, ridgecap: true },
    { label: "Full warranty compliance documentation", typical: false, ridgecap: true },
    { label: "Negotiates directly with your adjuster", typical: false, ridgecap: true },
    { label: "Uses true hip & ridge cap shingles", typical: false, ridgecap: true },
    { label: "Upgrades all Homeowners to Hail Resistant Shingles at No Charge", typical: false, ridgecap: true },
    { label: "Inspects and repairs decking", typical: false, ridgecap: true },
  ];

  return (
    <section id="help" className="py-24 bg-[#f8f5f0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#f97316]/15 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            <i className="ri-home-gear-line"></i>
            How RidgeCap GC Helps
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#1a1a2e] leading-tight mb-4">
            We Maximize Your Claim <span className="text-[#f97316]">AND</span> Deliver a Roof That Lasts
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            Our proven process ensures you get every dollar from your insurance claim while receiving a quality installation that&apos;s built to last — with full manufacturer warranty coverage.
          </p>
        </div>

        {/* Process Timeline */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
          {process.map((step) => (
            <div key={step.num} className="bg-white rounded-xl p-6 border border-gray-100">
              <div className="flex items-center justify-between mb-4">
                <div className="text-3xl font-black text-[#f97316]/30">{step.num}</div>
                <div className="bg-[#f97316]/10 text-[#f97316] text-xs font-bold px-3 py-1 rounded-full">
                  {step.time}
                </div>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-[#1a1a2e] rounded-lg mb-4">
                <i className={`${step.icon} text-[#f97316] text-lg`}></i>
              </div>
              <h3 className="text-[#1a1a2e] font-bold text-base mb-2">{step.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* Comparison */}
        <div className="bg-white rounded-2xl overflow-hidden border border-gray-100">
          <div className="grid grid-cols-3 bg-[#1a1a2e] text-white">
            <div className="p-5 text-sm font-bold text-white/60 uppercase tracking-wide">What You Get</div>
            <div className="p-5 text-sm font-bold text-center text-white/60 uppercase tracking-wide border-l border-white/10">
              Typical Contractor
            </div>
            <div className="p-5 text-sm font-bold text-center text-[#f97316] uppercase tracking-wide border-l border-white/10">
              RidgeCap GC
            </div>
          </div>
          {comparisons.map((row, i) => (
            <div
              key={row.label}
              className={`grid grid-cols-3 border-b border-gray-100 ${i % 2 === 0 ? "bg-white" : "bg-[#f8f5f0]"}`}
            >
              <div className="p-4 text-sm text-gray-700 font-medium">{row.label}</div>
              <div className="p-4 flex items-center justify-center border-l border-gray-100">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-close-line text-red-400 text-lg"></i>
                </div>
              </div>
              <div className="p-4 flex items-center justify-center border-l border-gray-100">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-[#f97316] text-lg"></i>
                </div>
              </div>
            </div>
          ))}
          <div className="p-6 text-center bg-[#f97316]/5 border-t border-[#f97316]/20">
            <a
              href="#cta"
              className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-8 py-4 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
            >
              Schedule Free Inspection &amp; Claim Review
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
